
const state = function () {
  return {
    loading: false,
    courseList: [],
    stateCourseList: [],
    certificates: {
      startDate: null,
      endDate: null
    },
    studentCompletionList: [],
    studentExceptionList: [],
    studentCompletionForm: {
      LK_STATE_ID: null,
      COURSE_ID: null,
      START_DATE: null,
      END_DATE: null
    },
    recruiterReferralForm: {
      START_DATE: null,
      END_DATE: null
    },
    scheduleReportForm: {
      START_DATE: null,
      END_DATE: null
    },
    affiliateScheduleForm: {
      COURSE_ID: null,
      START_DATE: null,
      END_DATE: null,
      AFFILIATE_CODES: [],
    },
    affiliateScheduleList: [],
    selectedSchedules:     [],
    selectedStudents:      []
  }
}

export default {
  ...state()
}

export const initialState = state()
